export const UPDATE_CANCEL_URL = 'UPDATE_CANCEL_URL';

export const updateCancelUrl = cancelUrl => {
  return {
    type: UPDATE_CANCEL_URL,
    payload: cancelUrl,
  };
};
